<template>
  <el-dialog :lock-scroll="true" :top="'50px'" :width="'60%'" v-model="show" title="Teste">

    <template v-slot:title>
      <div  style="border-bottom: #e0e0e0 1px solid;padding: 20px;">
        <div class="modal-title" style="display: flex;width: calc(100% - 50px)">
          Minhas Faturas
        </div>
      </div>
    </template>
    <div class="itm" style="display: flex;background: #eeeeee;">


      <div  style="padding: 10px;width: 30px;font-size: 12px;">
        {{KT('invoice.id')}}

      </div>

      <div  style="flex: 1;padding: 10px;font-size: 12px;text-align: center;">
        {{KT('invoice.dueDate')}}

      </div>
      <div  style="flex: 1;padding: 10px;font-size: 12px;text-align: center;">
        {{KT('invoice.value')}}

      </div>
      <div  style="width: 200px;padding: 10px;font-size: 12px;text-align: center;">
        {{KT('invoice.status')}}
      </div>
      <div  style="width: 120px;padding: 10px;font-size: 12px;text-align: center;">
        {{KT('invoice.paidDate')}}
      </div>
      <div style="width: 200px;padding: 10px;font-size: 12px;text-align: center;">

      </div>
    </div>
    <div style="height: calc(100vh - 300px); overflow: hidden; overflow-y: scroll;">



      <div class="itm" v-for="(u,k) in filteredUsers" :key="k" @click="selected = (selected!==u.id)?u.id:0" :class="{tr1: (k%2),tr2: !(k%2),selected: (selected === u.id)}" style="display: flex;">

        <div style="width: 30px;padding: 10px;font-size: 14px;">{{u.id}}</div>
        <div style="flex: 1;padding: 10px;font-size: 14px;text-align: center;">{{new Date(u.DueDateTime*1000).toLocaleDateString()}}</div>
        <div style="flex: 1;padding: 10px;font-size: 14px;text-align: center;">{{$t('units.currency',{value: u.value})}}</div>
        <div style="width: 200px;padding: 10px;font-size: 14px;text-align: center;">{{KT('invoice.statuses.'+u.status)}}</div>
        <div style="width: 120px;padding: 10px;font-size: 14px;text-align: center;">{{(u.payment_date==0)?$t('no'):u.payment_date}}</div>
        <div style="width: 190px;padding: 10px;font-size: 14px;text-align: center;"><a target="_blank" :href="u.link">Pagar agora</a></div>
      </div>

    </div>

  </el-dialog>
</template>


<script setup>




import 'element-plus/es/components/input/style/css'
import 'element-plus/es/components/button/style/css'
import 'element-plus/es/components/switch/style/css'
import 'element-plus/es/components/select/style/css'
import 'element-plus/es/components/option/style/css'
import 'element-plus/es/components/dialog/style/css'
import 'element-plus/es/components/tab-pane/style/css'
import 'element-plus/es/components/tabs/style/css'
import 'element-plus/es/components/message/style/css'
import 'element-plus/es/components/checkbox/style/css'

import {ElDialog} from "element-plus";

import {ref,defineExpose} from 'vue';


const selected = ref(0);
const show = ref(false);





const filteredUsers = ref([]);




const showInvoices = ()=>{

    show.value = true;

    fetch("/tarkan/invoices").then((response)=>{
      response.json().then((json)=>{
          filteredUsers.value = json;
      })
    });
}


defineExpose({
  showInvoices
});





</script>

<style>

.itm{
  border-bottom: silver 1px dotted;
}

.itm div{
  border-right: silver 1px dotted;
}


.tr1{
  background: #f3f3f3;
}

.tr2{
  background: #f8f8f8;
}

.selected{
  background: rgba(5, 167, 227, 0.05) !important;
}

.itm div:last-child{
  border-right: none;
}

.el-select.el-select--large{
  width: 100%;
}

.el-dialog__header,.el-dialog__body,.el-dialog__footer{
  padding: 0px !important;
}

.el-dialog__footer{
  margin-top: 0px;
}

.el-tabs__nav-wrap{
  padding-left: 20px;
  padding-right: 20px;
}

.el-tabs__content{
  padding-left: 20px;
  padding-right: 20px;
}




.danger{
  --el-button-text-color: var(--el-color-danger) !important;
  --el-button-bg-color: #fef0f0 !important;
  --el-button-border-color: #fbc4c4 !important;
  --el-button-hover-text-color: var(--el-color-white) !important;
  --el-button-hover-bg-color: var(--el-color-danger) !important;
  --el-button-hover-border-color: var(--el-color-danger) !important;
  --el-button-active-text-color: var(--el-color-white) !important;
  --el-button-active-border-color: var(--el-color-danger) !important;
}

</style>